import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'
import CheckboxField from 'components/form/checkbox'
import { connect } from 'react-redux'
import CustomDmTemplate from '../../facebook/send-facebook-blast/custom-template'

const selector = formValueSelector('widget')

export const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

export const SendInstagramDmFields = ({
  selectedAction,
  includeBackupDms,
  experienceType,
  name
}) => (
  <div className='row select-group'>
    <div className='col-sm-4 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='TEMPLATE_GENERIC'
      >
        <option value='TEMPLATE_GENERIC'>Generic DM Template</option>
        <option value='TEMPLATE_CUSTOM'>Custom Template</option>
      </Field>
      {experienceType === 'INSTAGRAM_COUPON' && (
        <Field
          name={`${name}.includeBackupDms`}
          component={CheckboxField}
          label='Include fallback and depleted DMs'
          className='icheckbox_square'
        />
      )}
    </div>
    {selectedAction === 'TEMPLATE_GENERIC' && (
      <div className='col-sm-12'>
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.igDmText`}
          placeholder='DM Text'
          require
        />
        <Field
          component={MessageInputWithError}
          label='Image URL'
          name={`${name}.igDmImageUrl`}
          placeholder='Image URL'
        />
        <Field
          component={MessageInputWithError}
          label='Template Title'
          name={`${name}.igTemplateTitle`}
          placeholder='Template Heading'
        />
        <Field
          component={MessageInputWithError}
          label='Template Action URL'
          name={`${name}.igTemplateActionUrl`}
          placeholder='Template Action URL (where to go when user clicks on the DM)'
        />
      </div>
    )}
    {selectedAction === 'TEMPLATE_CUSTOM' && (
      <div className='br-has-checkbox col-sm-12'>
        <Field component={CustomDmTemplate} name={`${name}.customDmTemplate`} />
      </div>
    )}
    {includeBackupDms && (
      <div className='col-sm-12'>
        <span>
          <strong>FALLBACK MESSAGE</strong>
        </span>
        <br />
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.igDmFallbackText`}
          placeholder='Fallback DM Text'
          require
        />
        <Field
          component={MessageInputWithError}
          label='Image URL'
          name={`${name}.igDmFallbackImageUrl`}
          placeholder='Fallback DM Image URL'
        />
        <Field
          component={MessageInputWithError}
          label='Template Title'
          name={`${name}.igTemplateFallbackTitle`}
          placeholder='Fallback Template Heading'
        />
        <Field
          component={MessageInputWithError}
          label='Template Action URL'
          name={`${name}.igTemplateFallbackActionUrl`}
          placeholder='Fallback Template Action URL (where to go when user clicks on the DM)'
        />
        <span>
          <strong>DEPLETED MESSAGE</strong>
        </span>
        <br />
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.igDmDepletedText`}
          placeholder='Depleted DM Text'
          require
        />
        <Field
          component={MessageInputWithError}
          label='Depleted Image URL'
          name={`${name}.igDmDepletedImageUrl`}
          placeholder='Depleted Image URL'
        />
        <Field
          component={MessageInputWithError}
          label='Template Title'
          name={`${name}.igTemplateDepletedTitle`}
          placeholder='Depleted Template Heading'
        />
        <Field
          component={MessageInputWithError}
          label='Template Action URL'
          name={`${name}.igTemplateDepletedActionUrl`}
          placeholder='DepletedTemplate Action URL (where to go when user clicks on the DM)'
        />
      </div>
    )}
  </div>
)

SendInstagramDmFields.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string,
  includeBackupDms: PropTypes.bool,
  experienceType: PropTypes.string
}

const SendInstagramDmFieldsWithTypes = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`),
  includeBackupDms: selector(state, `${props.name}.includeBackupDms`),
  experienceType: selector(state, 'type')
}))(SendInstagramDmFields)

export default SendInstagramDmFieldsWithTypes



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/instagram/send-instagram-dm/index.js